import React from 'react';
import { Table } from 'react-bootstrap'
import { formatPercent, priceColor } from '../Dashboard/Helpers';

const StockTech = ({ sectorInfo }) => {

  function mapTickers() {
    return sectorInfo.map((item) => {
      return (
        <tr key={ item.symbol }>
          <td>{ item.symbol }</td>
          <td>{ item.name }</td>
          <td>{ item.price }</td>
          <td className={priceColor(item.percentChange)}>{ formatPercent(item.percentChange) }</td>
          <td>{ item.sectorWeight }%</td>
          <td>{ item.previousClose }</td>
          <td>{ item.open }</td>
          <td>{ item.quarterly }</td>
        </tr>
      );
    });
  }

  return (
    <Table responsive bordered className="sector-technicals-table">
      <thead>
        <tr>
          <th>Ticker</th>
          <th>Name</th>
          <th>Price</th>
          <th>% Change</th>
          <th>Sector Weight</th>     
          <th>Previous Close</th>
          <th>Open</th>
          <th>Quarterly</th>
        </tr>
      </thead>
      <tbody>
        { mapTickers() }
      </tbody>
    </Table>
  );
}

export default StockTech;